import { ModelBase } from '../../core/model/model-base';
import { Translation } from '../../core/model/translation';

export class ErrandCategory extends ModelBase {
  constructor(dataContext?: ErrandCategory) {
    super();
    this.name = [];
    this.rentalObjectCategories = [];
    this.subcategories = [];
    this.isEnabled = true;
    this.canDelete = true;
    this.rentalObjectAccessNeeded = false;
    this.tenantErrandType = TenantErrandType.FaultNotification;

    if (dataContext) {
      Object.assign(this, dataContext);
      this.subcategories = (dataContext.subcategories || []).map(item => new ErrandSubCategory(item));
    }
  }

  name: Translation[];
  currentLanguageName: string;
  tenantErrandType: TenantErrandType;
  currentLanguageTenantErrandTypeName: string;
  rentalObjectAccessNeeded: boolean;
  rentalObjectCategories: string[];
  internalDescription: string;
  isEnabled: boolean;
  canDelete: boolean;
  subcategories: ErrandSubCategory[];

  toString() {
    return this.currentLanguageName;
  }

  get tenantErrandTypeTranslation() {
    return TenantErrandTypeToString(this.tenantErrandType);
  }
}

export class ErrandSubCategory extends ModelBase {
  constructor(dataContext?: ErrandSubCategory) {
    super();
    this.name = [];
    this.isEnabled = true;
    this.canDelete = true;

    if (dataContext) {
      Object.assign(this, dataContext);
    }
  }

  name: Translation[];
  currentLanguageName: string;
  internalDescription: string;
  defaultTagId: string;
  isEnabled: boolean;
  canDelete: boolean;

  toString() {
    return this.currentLanguageName;
  }
}

export enum TenantErrandType {
  Unknown = 0,
  FaultNotification = 1,
  ServiceRequest = 2,
  Other = 3,
}

export const TenantErrandTypeValues: readonly TenantErrandType[] = [
  TenantErrandType.FaultNotification,
  TenantErrandType.ServiceRequest,
  TenantErrandType.Other,
];

export function TenantErrandTypeToString(tenantErrandType: TenantErrandType): string {
  switch (tenantErrandType) {
    case TenantErrandType.FaultNotification:
      return 'CONST.TENANT_ERRANDTYPE.FAULT_NOTIFICATION';
    case TenantErrandType.ServiceRequest:
      return 'CONST.TENANT_ERRANDTYPE.SERVICE_REQUEST';
    case TenantErrandType.Other:
      return 'CONST.TENANT_ERRANDTYPE.OTHER';
    default:
      return 'COMMON.NOT_SPECIFIED';
  }
}

export interface TenantErrandTypeMetadata {
  tenantErrandType: TenantErrandType;
}

export interface TenantErrandTypeDisplayOption {
  tenantErrandType: TenantErrandType;
  name: string;
}

export function getTenantErrandTypeDisplayOptions(
  items: readonly TenantErrandTypeMetadata[]
): TenantErrandTypeDisplayOption[] {
  const types = new Set<TenantErrandType>();
  (items ?? []).forEach(item => {
    if (item?.tenantErrandType === null || item?.tenantErrandType === undefined) return;
    types.add(item.tenantErrandType);
  });

  return [...types]
    .sort((left, right) => left - right)
    .map(tenantErrandType => ({
      tenantErrandType,
      name: TenantErrandTypeToString(tenantErrandType),
    }));
}

export interface ErrandCategoryDefaults {
  tenantErrandTypes: TenantErrandTypeOption[];
  rentalObjectCategories: ErrandRentalObjectCategoryOption[];
  accessRestrictions: ErrandAccessRestrictionOption[];
}

export interface ErrandAccessRestrictionOption {
  id: string;
  name: string;
}

export interface TenantErrandTypeOption {
  id: string;
  tenantErrandType: TenantErrandType;
  name: Translation[];
  currentLanguageName: string;
}

export interface ErrandRentalObjectCategoryOption {
  id: string;
  category: string;
  name: Translation[];
  currentLanguageName: string;
}
